<!-- Header -->
<div class="header center sticky-autohide" [class.transparent-light]="isTransparent">

  <div class="container">
    <!-- Logo -->
    <div class="header-logo">
      <a routerLink="/">
        <img class="logo-dark" src="assets/images/logo-dark.png" alt="logo-dark">
      </a>
      <a routerLink="/">
        <img class="logo-light" src="assets/images/logo-light.png" alt="logo-light">
      </a>
    </div>
    <!-- Menu -->
    <div class="header-menu menu-close-auto">
      <ul class="nav">
        <li class="nav-item" *ngFor="let item of menuItems">
          <a class="nav-link" (click)="scrollToSection(item.link)">
            {{ item.name }}
          </a>
        </li>
      </ul>
    </div>
    <!-- Menu Extra -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li *ngFor="let social of socialLinks">
          <a [routerLink]="social.link">
            <i [class]="social.icon"></i>
          </a>
        </li>
      </ul>
    </div>
    <!-- Menu Toggle -->
    <button class="header-toggle">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->

<!-- Hero section -->
<div class="rounded-image rd-imgs" id="home">
    <div class="section-lg section-fullscreen">
        <div class="container">
            <div class="position-middle">
                <div class="row">
                    <div class="col-12">
                        <h1 class="display-5 fw-thin color-white">Together <span class="fw-black">we stand,</span> together we fall.<br>All for one and <span class="fw-black">one for all.</span></h1>
                        <div class="inline-btn mt-30">
                            <a class="lightbox-media-box button-circle button-circle-md button-circle-outline-dark button-circle-hover-slide mrt-30" (click)="openPopup()">
                                <i class="bi bi-play-fill"></i>
                                <i class="bi bi-play-fill"></i>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- end Hero section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Welcome section -->
<section>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="hexagon-big-green shapes-wrap" data-opacity="0.15"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 heading-style-one text-center">
                <h5 class="pink-color uppercase">We bring the best benefits to you</h5>
                <h2><span class="fw-black">Features</span></h2>
            </div>
        </div>

        <div class="row mrt-80 position-relative z-index-99">
            <div class="col-md-3 col-sm-6" *ngFor="let feature of features">
                <div class="dn-feature-box text-center mrb-20">
                    <i class="img-icon big-icon" [ngClass]="feature.icon"></i>
                    <h3>{{ feature.title }}</h3>
                    <p>{{ feature.desc }}</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- end Welcome section -->

<!-- What We Do section -->
<div class="section pd-b-0" id="about">
  <div class="container-fluid pd-0">
    <div class="row row-flex flex-center">
      <div class="col-md-6 col-sm-12">
        <div class="col-inner pd-t-70 pd-b-50 spacer border-top border-bottom">
          <div class="heading-style-one">
            <h6 class="green-color uppercase">What We Do</h6>
            <h2 class="display-6 fw-black">We can do all these things.</h2>
          </div>
          <div class="mrt-30">
            <div class="progress-box progress-gradient mrb-30" *ngFor="let skill of skills">
              <h6 class="fw-thin pink-color">{{ skill.name }}</h6>
              <div class="animated-progress">
                <div [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"><span>{{ skill.level }}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-12 bg-flex-cover" style="background-image: url(assets/images/about/about-img.jpg);"></div>
    </div>
  </div>
</div>
<!-- end What We Do section -->

<!-- Portfolio section -->
<div class="section-md" id="work">
  <div class="container">
    <div class="row">
      <div class="col-md-12 heading-style-one text-center">
        <h5 class="pink-color uppercase">Our Portfolio</h5>
        <h2><span class="fw-black color-white">Love for photography. Eat sleep and breathe it. <br>Become a photograph.</span></h2>
      </div>
    </div>
    <div class="row mrt-50">
      <div class="row portfolio-grid g-2 g-lg-3 mrt-10">
        <!-- Portfolio box -->
        <div *ngFor="let work of works" class="col-12 col-md-4 portfolio-item">
                <div class="portfolio-box">
                    <div class="portfolio-img">
                        <img src="assets/images/portfolio/grid/{{work.img}}" alt="gallery-img">
                    </div>
                    <a routerLink="/portfolio-one"></a>
                    <div class="portfolio-title">
                        <div>
                            <h5 class="fw-normal">{{work.title}}</h5>
                            <span>{{work.category}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</div>
<!-- end Portfolio section -->

<!-- Counters section -->
<div class="section-sm">
  <div class="container">
    <div class="row counter-style-two">
      <div class="col-md-3 col-sm-6" *ngFor="let fact of funFacts">
        <div class="counter-wrap">
          <div class="float-start"><i class="bi" [ngClass]="fact.icon"></i></div>
          <div class="float-end">
            <h2 class="red-color"><span class="counter">{{fact.displayedNumber | number:'1.0-0'}}</span></h2>
            <h3>{{fact.desc}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div><!-- end container -->
</div>
<!-- end Counters section -->

<!-- Parallax section -->
<div class="section-xl bg-image parallax" style="background-image: url(assets/images/backgrounds/main-bg-2.jpg);">
  <div class="bg-dark-01">
    <div class="container text-center">
      <div class="row g-4">
        <div class="col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
          <h2 class="display-4 fw-black">Creating ideas and building brands that truly matter to people.</h2>
          <a class="button button-lg button-rounded button-gradient-1 mt-4" routerLink="/contact">Call Us</a>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Parallax section -->

<!-- Pricing section -->
<section class="section big-skew-box pd-b-0" id="pricing">
  <div class="bubble-gradient-blue shapes-wrap"></div>
  <div class="bubble-gradient-purple shapes-wrap"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12 heading-style-one text-center">
        <h5 class="green-color uppercase">Our Pricing Plans</h5>
        <h2><span class="fw-black">Simple pricing. No hidden costs. <br>Plans start at $0.</span></h2>
      </div>
    </div>
    <div class="row mrt-50">
      <div class="col-md-4 pricing-table" *ngFor="let plan of pricingPlans">
        <div class="pricing-box">
          <i [class]="plan.icon"></i>
          <h4>{{plan.name}}</h4>
          <h2><span>{{plan.price}}</span></h2>
          <ul>
            <li *ngFor="let feature of plan.features">
              <i [class]="feature.available ? 'bi bi-check2' : 'mdi mdi-close'"></i>
              <span>{{feature.value}}</span> {{feature.text}}
            </li>
          </ul>
          <div class="pricing-box-bottom">
            <a routerLink="/pricing-table" class="button button-lg btn-candy button-rounded">
              Get Started
            </a>
          </div>

        </div>

      </div>
    </div>
  </div>
</section>
<!-- end Pricing section -->

<!-- Testimonial section -->
<div class="section">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-12 heading-style-one text-center">
        <h6 class="yellow-color uppercase">Testimonials</h6>
        <h2 class="display-6 fw-black">Our Clients Saying About Us</h2>
      </div>
    </div>
    <owl-carousel-o [options]="testimonialOptions" class="owl-btn-center-lr mrt-80 testimonial testimonial-three pd-0">
        <ng-template carouselSlide *ngFor="let tes of testimonials">
            <!-- Testimonial box -->
            <div class="testimonial-item">
                <div class="testimonial-content">
                    <div class="testimonial-content-in radius-50">
                        <div class="img">
                            <img class="img-responsive border-radius-100" src="assets/images/team/{{tes.image}}" alt="client-img">
                        </div>
                        <h5>{{tes.name}}</h5>
                        <h6>{{tes.position}}</h6>
                        <p>{{tes.desc}}</p>
                    </div>
                </div>
            </div>
        </ng-template>
    </owl-carousel-o>
    <!-- end owl-carousel -->
  </div><!-- end container -->
</div>
<!-- end Testimonial section -->

<!-- Contact section -->
<div class="section-lg pd-t-0 pd-b-0" id="contact">
  <div class="bubble-big-gradient-purple shapes-wrap"></div>
    <div class="bubble-sm-gradient-blue shapes-wrap"></div>
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-sm-12 contact-box">
        <form (submit)="sendEmail($event)" #contactForm="ngForm">
          <div class="row">
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                  <label class="visually-hidden" for="user_name">Name</label>
                  <input class="border-radius" type="text" minlength="2" maxlength="15"
                      [class.is-invalid]="userName.invalid && userName.touched" name="user_name" id="name"
                      placeholder="Name *" [(ngModel)]="formData.user_name" #userName="ngModel" required>
                  <div *ngIf="userName.invalid && userName.touched" class="invalid-feedback mrb-10">
                      Name is required.
                  </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-6">
              <div class="form-group">
                  <label class="visually-hidden" for="user_email">Email</label>
                  <input class="border-radius" type="email" minlength="2" maxlength="35"
                      [class.is-invalid]="userEmail.invalid && userEmail.touched" name="user_email" class="md-input"
                      id="email" placeholder="Email *" [(ngModel)]="formData.user_email" #userEmail="ngModel" required
                      email>
                  <div *ngIf="userEmail.invalid && userEmail.touched" class="invalid-feedback mrb-10">
                      A valid email is required.
                  </div>
              </div>
            </div>
          </div>
          <div class="form-group">
              <label class="visually-hidden" for="message">Project Details</label>
              <textarea class="border-radius" name="message"
                  [class.is-invalid]="userMessage.invalid && userMessage.touched" class="md-textarea" id="message"
                  rows="7" placeholder="Project Details" [(ngModel)]="formData.message" #userMessage="ngModel"
                  required></textarea>
              <div *ngIf="userMessage.invalid && userMessage.touched" class="invalid-feedback mb-10">
                  Project details are required.
              </div>
          </div>
          <div class="text-right">
            <button type="submit" name="submit" class="button btn-candy button-lg button-rounded m-0" [disabled]="contactForm.invalid" value="Send Mail">Send Mail</button>
          </div>
        </form>
        <div class="messages mrt-20 text-center"></div>
      </div>
      <!-- Form End -->
  
      <div class="col-12 col-lg-6 col-xl-6 col-md-12 col-sm-12 position-relative pd-0">
        <div id="myMap">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d805170.0496601658!2d145.05313529999998!3d-37.9725665!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad646b5d2ba4df7%3A0x4045675218ccd90!2sMelbourne%20VIC%2C%20Australia!5e0!3m2!1sen!2s!4v1753292239264!5m2!1sen!2s" class="responsive-map" allowfullscreen loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
      <!-- Map End -->
    </div>
  </div><!-- end container -->
</div>
<!-- end Contact section -->
